export const COUNTY = {
  ZAGREB: 'zagreb',
  GRAD_ZAGREB: 'grad zagreb',
};

export const SETTLEMENT = {
  OSIJEK: 'osijek',
};

export const MAP = {
  DEFAULT_VIEWPORT: {
    center: [44.75453548416007, 16.435546875000004],
    zoom: 7,
  },
};

export const CROATIA_COUNTRY_NAME = 'Hrvatska';

export const TYPE = {
  MUNICIPALITY: 'MUNICIPALITY',
};

export default { COUNTY, MAP, CROATIA_COUNTRY_NAME, TYPE, SETTLEMENT };
